import React, { memo } from 'react';

import * as S from './ArticleByline.styles';

export interface ArticleBylineProps {
  articleAuthor?: string;
  authorBio?: string;
  authorImage?: { url: string };
  date?: string;
  wordsByLabel?: string;
  dateLabel?: string;
}

const ArticleByline: React.FunctionComponent<ArticleBylineProps> = ({
  articleAuthor,
  authorBio,
  authorImage,
  date,
  wordsByLabel,
  dateLabel,
}) => {
  if (!articleAuthor) return null;

  return (
    <S.Wrapper>
      {authorImage && <S.Avatar src={authorImage.url} />}

      <S.Meta>
        {articleAuthor && (
          <S.Row>
            <S.Label>{wordsByLabel || 'Words by'} </S.Label>
            <S.Value>{articleAuthor}</S.Value>
          </S.Row>
        )}
        {date && (
          <S.Row>
            <S.Label>{dateLabel || 'Date'} </S.Label>
            <S.Value>{date}</S.Value>
          </S.Row>
        )}
        {authorBio && <S.Bio>{authorBio}</S.Bio>}
      </S.Meta>
    </S.Wrapper>
  );
};

export default memo(ArticleByline);
